import _setPrototypeOf from './setPrototypeOf.js';

function _inherits(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:true,configurable:true}}),Object.defineProperty(t,"prototype",{writable:false}),e&&_setPrototypeOf(t,e);}

export { _inherits as default };
//# sourceMappingURL=inherits.js.map
